import ObjectTask from './container/ObjectTask';
import ObjectTaskViewAll from './container/ObjectTaskViewAll';

export { ObjectTask, ObjectTaskViewAll };



// WEBPACK FOOTER //
// ./src/views/ObjectTask/index.js